import { SbBlokData, storyblokEditable } from "@storyblok/react"
import { useRouter } from "next/router"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import LazyYoutube from "@/components/testimonials/LazyYoutube"

export interface IYoutubeEmbed extends SbBlokData {
  header: string
  videoId: string
  content: string
  buttonLabel: string
  bgColor: "white" | "orange1"
  path?: string
}

export default function YoutubeEmbed({ blok }: { blok: IYoutubeEmbed }) {
  const router = useRouter()
  const { header, videoId, content, buttonLabel, bgColor, path } = blok

  const handleClick = () => {
    const normalizedPath = path?.startsWith("/") ? path.slice(1) : path
    router.push(normalizedPath ? `/${normalizedPath}` : `/shipments/new`)
  }

  return (
    <section
      className={`page-padding relative w-full flex flex-col items-center space-y-8  bg-${bgColor}`}
      {...storyblokEditable(blok)}
    >
      {header && (
        <h3 className="font-montserrat text-4xl text-blue7 text-center">
          {header}
        </h3>
      )}
      <LazyYoutube videoId={videoId} />
      {content && <p className="text-blue22 text-2xl font-medium">{content}</p>}
      {buttonLabel && (
        <PrimaryButton className="" onClick={handleClick}>
          {buttonLabel || "Register Today!"}
        </PrimaryButton>
      )}
    </section>
  )
}
